import React, { useState } from 'react';
import { getUserThumbnailUrl, getUserInitials } from '../utils/userUtils';

const UserAvatar = ({ 
  userProfile, 
  size = 'md', 
  className = '',
  showName = false 
}) => {
  const [imageError, setImageError] = useState(false);
  
  // Tamaños disponibles
  const sizes = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-xl'
  };
  
  const sizeClass = sizes[size] || sizes.md;
  const thumbnailUrl = getUserThumbnailUrl(userProfile);
  const initials = getUserInitials(userProfile);
  
  const handleImageError = () => {
    setImageError(true);
  };
  
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className={`${sizeClass} rounded-full overflow-hidden bg-gray-600 flex items-center justify-center flex-shrink-0`}>
        {!imageError && userProfile?.agent_photo ? (
          <img
            src={thumbnailUrl}
            alt={`${userProfile.username || userProfile.email} avatar`}
            className="w-full h-full object-cover"
            onError={handleImageError}
          />
        ) : (
          <span className="font-medium text-white">
            {initials}
          </span>
        )}
      </div>
      
      {showName && userProfile && (
        <div className="flex flex-col">
          <span className="text-sm font-medium text-gray-200">
            {userProfile.username || userProfile.email?.split('@')[0]}
          </span>
          {userProfile.email && (
            <span className="text-xs text-gray-400">
              {userProfile.email}
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default UserAvatar;